import { STUDENT_ID_INTAKE_MODES } from '../domain/identity/studentIdIntake';
import { STUDENT_ID_INTAKE_RADIO_HELP } from '../domain/identity/generatedIdOverlayCopy';

/**
 * Generate / use-existing / lead checkpoint for Add User (flag-gated by parent).
 */
const StudentIdIntakeCheckpoint = ({
  mode,
  typedId,
  onModeChange,
  onTypedIdChange,
  requireTypedId,
  showTypedId,
  previewUnixUsername = '',
}) => {
  const assignedUnix = String(previewUnixUsername || '').trim();

  return (
    <div className="mb-4 space-y-3">
      <p className="block text-sm font-medium" style={{ color: 'var(--color-text)' }}>
        Student ID and Unix username
      </p>
      <div className="space-y-2 text-sm" style={{ color: 'var(--color-text)' }}>
        <label className="flex items-start gap-2">
          <input
            type="radio"
            name="studentIdIntakeMode"
            value={STUDENT_ID_INTAKE_MODES.GENERATE}
            checked={mode === STUDENT_ID_INTAKE_MODES.GENERATE}
            onChange={onModeChange}
            className="mt-1"
          />
          <span>
            <span className="font-medium">Generate</span>
            <span className="block text-xs" style={{ color: 'var(--color-text-secondary)' }}>
              {STUDENT_ID_INTAKE_RADIO_HELP.generate}
            </span>
          </span>
        </label>
        <label className="flex items-start gap-2">
          <input
            type="radio"
            name="studentIdIntakeMode"
            value={STUDENT_ID_INTAKE_MODES.EXISTING}
            checked={mode === STUDENT_ID_INTAKE_MODES.EXISTING}
            onChange={onModeChange}
            className="mt-1"
          />
          <span>
            <span className="font-medium">Use existing</span>
            <span className="block text-xs" style={{ color: 'var(--color-text-secondary)' }}>
              {STUDENT_ID_INTAKE_RADIO_HELP.existing}
            </span>
          </span>
        </label>
        <label className="flex items-start gap-2">
          <input
            type="radio"
            name="studentIdIntakeMode"
            value={STUDENT_ID_INTAKE_MODES.LEAD}
            checked={mode === STUDENT_ID_INTAKE_MODES.LEAD}
            onChange={onModeChange}
            className="mt-1"
          />
          <span>
            <span className="font-medium">Lead</span>
            <span className="block text-xs" style={{ color: 'var(--color-text-secondary)' }}>
              {STUDENT_ID_INTAKE_RADIO_HELP.lead}
            </span>
          </span>
        </label>
      </div>
      {showTypedId ? (
        <div>
          <label className="block text-sm font-medium mb-2" style={{ color: 'var(--color-text)' }}>
            VE Student ID {requireTypedId ? <span className="text-red-500">*</span> : null}
          </label>
          <input
            type="text"
            name="veStudentId"
            value={typedId}
            onChange={onTypedIdChange}
            placeholder={
              requireTypedId
                ? 'Enter existing Student ID'
                : 'Optional — leave blank to use the current create path'
            }
            required={requireTypedId}
            className="w-full px-4 py-3 theme-input rounded-lg theme-focus"
            style={{
              backgroundColor: 'var(--color-surface)',
              border: '2px solid var(--color-border)',
              color: 'var(--color-text)',
            }}
          />
          {assignedUnix && mode === STUDENT_ID_INTAKE_MODES.EXISTING ? (
            <p className="mt-2 text-sm" style={{ color: 'var(--color-text-secondary)' }}>
              Unix username that will be attached:{' '}
              <span className="font-semibold" style={{ color: 'var(--color-text)' }}>
                {assignedUnix}
              </span>
            </p>
          ) : null}
        </div>
      ) : null}
    </div>
  );
};

export default StudentIdIntakeCheckpoint;
